import React from 'react'
import { CardInfo } from '../../../../../../Portfolio_R/SummaryCharts/components/CardInfo'
import ChartProgressBar from '../../../../../../Portfolio_R/SummaryCharts/components/ChartProgressBar'

const ApprovedIdbAmounts = ({ mp, t, formatMillions }) => {
    return (
        <div className="amounts">
            <div>
                <h3 className="chart-title">{t('one_pager_report.bid_amount')}</h3>
                <div className="chart-content" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr' }}>
                    <CardInfo
                        title={t('one_pager_report.original')}
                        data={`${formatMillions(mp.fields.idbApprovedAmountOriginal)} MM`}
                    />
                    <CardInfo
                        title={t('one_pager_report.current_title')}
                        data={`${formatMillions(mp.fields.idbApprovedAmountCurrent)} MM`}
                    />
                </div>
            </div>
            <div>
                <h3 className="chart-title">{t('one_pager_report.accumulate_disbursements')}</h3>
                <div className="chart-content">
                    <ChartProgressBar
                        completed={mp.fields.disbursementPercent}
                        totalAmount={mp.fields.disbursementAmount + mp.fields.withoutDisbursingAmount}
                        disbursmentAmount={mp.fields.disbursementAmount}
                    />
                </div>
            </div>
        </div>
    )
}

export default ApprovedIdbAmounts